import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { getEmployees, getInActiveEmployees, bulkDeactivateEmployees } from '../../actions/userActions/employeeAction';
import { downloadEmployee } from '../../actions/userActions/downloadEmployeeAction';
import { getTeams } from '../../actions/userActions/teamAction';
import { getCities } from '../../actions/userActions/cityAction';
import { getDesignations } from '../../actions/userActions/designationAction';
import './Employee.css';
import DynamicTable from '../reuse_components/DynamicTable';
import BodySmallMedium from '../designSystem/BodySmallMedium';
import Heading6Regular from '../designSystem/Heading6Regular';
import CustomPagination from '../subComponents/pagination/CustomPagination';
import EmployeeHeader from './EmployeeHeader';
import CustomFilterSelect from '../designSystem/CustomFilterSelect'; // Import your filter component
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import chevron_rightIcon from "../../assets/images/chevron_rightIcon.svg";
import thIcon from "../../assets/images/thIcon.svg";
import {
  DEFAULT_PAGE,
  DEFAULT_SEARCH,
  DEFAULT_STATUS
} from '../../Constatns';
import { PERMISSIONS } from '../../Permissions';
import ItemsPerPageSelector from '../subComponents/pagination/ItemsPerPageSelector';
import { FilterBar } from '../subComponents/Filter/GenericFilters';
import LoadingOverlay from '../loadingOverlay/LoadingOverlay';
import { getEmployeeLookup } from '../../actions/userActions/employeeLookupAction';
import { t } from '../../locales/translate';
const EMPLOYEE_STATE_KEY = "employeeFiltersState";
const MODULE_FLAG = "insideEmployeeModule";
const EMPLOYEE_ROUTES = [
  "/admin/employees",
  "/admin/addemployees",
  "/admin/updateemployees",
];
const isEmployeeModulePath = (path = "") =>
  EMPLOYEE_ROUTES.some(route => path.toLowerCase().includes(route));
function Employees() {
  const dispatch = useDispatch();
const history = useHistory();
useEffect(() => {
  const clearModuleState = () => {
    sessionStorage.removeItem(MODULE_FLAG);
    localStorage.removeItem(EMPLOYEE_STATE_KEY);
  };

  const unlisten = history.listen(({ pathname }) => {
    if (!isEmployeeModulePath(pathname)) {
      clearModuleState();
    }
  });

  return () => {
    unlisten();
    if (!isEmployeeModulePath(history.location.pathname)) {
      clearModuleState();
    }
  };
}, [history]);

const [query, setQuery] = useState('');
const [previousQuery, setPreviousQuery] = useState('');
const [currentPage, setCurrentPage] = useState(1);
const [permission, setPermission] = useState(false);
const [statusFilter, setStatusFilter] = useState(2);
const [teamFilter, setTeamFilter] = useState('');
const [showFilters, setShowFilters] = useState(false);
const [cityFilter, setCityFilter] = useState('');
const [designationFilter, setDesignationFilter] = useState('');
const [itemsPerPage, setItemsPerPage] = useState(10);
const [isInitialized, setIsInitialized] = useState(false);
const [lastLoginFilter, setLastLoginFilter] = useState('');
const [todayAccessedFilter, setTodayAccessedFilter] = useState('');
const [selectedEmployeeIds, setSelectedEmployeeIds] = useState([]);
const [showDeactivateModal, setShowDeactivateModal] = useState(false);
const [isBulkDeactivating, setIsBulkDeactivating] = useState(false);

  
  const user = JSON.parse(localStorage.getItem("user"));
  const userTeamId = user?.result[0]?.user?.teamId; 
  const userTeamName = user?.result[0]?.user?.teamName;

// Constants
const DEFAULT_PAGE_SIZE = 10;
const pageNumber = -1;
const ACTIVE_STATUS = 2;
const INACTIVE_STATUS = 3;
  
  const { isLoadingInActiveEmployees } = useSelector((state) => state.employees_reducer);
  const employees = useSelector((state) => state.employees_reducer.employees);
  const inActiveEmployees = useSelector((state) => state.employees_reducer.InActivEemployees);
  const teams = useSelector((state) => state.teams_reducer.teams);
 
  const cities = useSelector((state) => state.cities_reducer.cities);

  const designations = useSelector((state) => state.designations_reducer.designations);

  const permissions = JSON.parse(localStorage.getItem('permissionsList'));
  const isEmployeesLoading = useSelector((state) => state.employees_reducer.isEmployeesLoading);
  const isCitiesLoading = useSelector((state) => state.cities_reducer.isCitiesLoading);
  const isDesignationsLoading = useSelector((state) => state.designations_reducer.isDesignationsLoading);
  const isEmployeeLookupLoading = useSelector((state) => state.employeeLookupReducer.isEmployeeLookupLoading);
  const isLoading = isEmployeesLoading || isEmployeeLookupLoading;
  const employeeLookups = useSelector((state) => 
    {
      return state.employeeLookupReducer.lookups

    });
    
const citiesData = employeeLookups.cities || [];
const designationsData = employeeLookups.designations || [];

const teamsData = employeeLookups.teams || [];
  
  // Utility functions
  const getStatusNameById = (statusId) => {
    const statusMap = { 1: 'All', 2: 'Active', 3: 'Inactive' };
    return statusMap[statusId] || '';
  };
  
  const getStatusIdByName = (statusName) => {
    const statusNameMap = { 'All': 1, 'Active': 2, 'Inactive': 3 };
    return statusNameMap[statusName] || DEFAULT_STATUS;
  };

  const getTotalPaginationInfo = () => {
    if (statusFilter === 3) {
      return {
        totalCount: inActiveEmployees?.totalCount || 0,
        totalPages: inActiveEmployees?.totalPages || 0,
      };
    }
    if (statusFilter === 2) {
      return {
        totalCount: employees?.totalCount || 0,
        totalPages: employees?.totalPages || 0,
      };
    }
    return {
      totalCount: employees?.totalCount || 0,
      totalPages: employees?.totalPages || 0,
    };
  };

  const formatDate = (dateString) => {
    if (!dateString) {
      return <span style={{ color: '#999' }}>Not Available</span>;
    }
    const date = new Date(dateString);
    const formattedDate = date.toLocaleDateString('en-US', {
      month: 'long', day: '2-digit', year: 'numeric',
    });
    const formattedTime = date.toLocaleTimeString('en-US', {
      hour: '2-digit', minute: '2-digit', hour12: true,
    }).toUpperCase();
    return `${formattedDate} - ${formattedTime}`;
  };

  const formatTodayAccessed = (lastAccessed) => {
    if (!lastAccessed) return 'No';
    const accessed = new Date(lastAccessed);
    if (Number.isNaN(accessed.getTime())) return 'No';
    const now = new Date();
    const sameDay =
      accessed.getFullYear() === now.getFullYear() &&
      accessed.getMonth() === now.getMonth() &&
      accessed.getDate() === now.getDate();
    return sameDay ? 'Yes' : 'No';
  };

  // Event handlers
  const handleSearchChange = (query) => {
    setQuery(query);
    setCurrentPage(1);
  };

  const toggleFilters = () => {
    setShowFilters(!showFilters);
  };

  const handleStatusFilterChange = (event) => {
    setStatusFilter(event.target.value);
    if (Number(event.target.value) !== ACTIVE_STATUS) {
      setTodayAccessedFilter('');
    }
    setCurrentPage(1);
  };

  const handleTeamFilterChange = (event) => {
    setTeamFilter(event.target.value);
    setCurrentPage(1);
  };

  const handleCityFilterChange = (event) => {
    setCityFilter(event.target.value);
    setCurrentPage(1);
  };

  const handleDesignationFilterChange = (event) => {
    setDesignationFilter(event.target.value);
    setCurrentPage(1);
  };

  const handleClearAllFilters = () => {
    setTeamFilter('');
    setCityFilter('');
    setDesignationFilter('');
    setQuery('');
    setLastLoginFilter('');
    setTodayAccessedFilter('');
    setSelectedEmployeeIds([]);
    setCurrentPage(1);
  };

  const handleLastLoginFilterChange = (event) => {
    setLastLoginFilter(event.target.value);
    setSelectedEmployeeIds([]);
    setCurrentPage(1);
  };

  const handleTodayAccessedFilterChange = (event) => {
    setTodayAccessedFilter(event.target.value);
    setCurrentPage(1);
  };

  const toggleSelectEmployee = (id) => {
    setSelectedEmployeeIds((prev) =>
      prev.includes(id) ? prev.filter((eid) => eid !== id) : [...prev, id]
    );
  };

  const handleSelectAll = (visibleIds) => {
    if (visibleIds.every((id) => selectedEmployeeIds.includes(id))) {
      setSelectedEmployeeIds((prev) => prev.filter((id) => !visibleIds.includes(id)));
    } else {
      setSelectedEmployeeIds((prev) => [...new Set([...prev, ...visibleIds])]);
    }
  };

  const handleConfirmDeactivate = async () => {
    setIsBulkDeactivating(true);
    try {
      await dispatch(bulkDeactivateEmployees(selectedEmployeeIds));
      setSelectedEmployeeIds([]);
      setShowDeactivateModal(false);
    } catch (_) {
      // error already dispatched to redux store/toast
    } finally {
      setIsBulkDeactivating(false);
    }
  };
const handleEmployeeDownload = () => {
  const isOnlyActive = statusFilter === ACTIVE_STATUS; 
  dispatch(
    downloadEmployee(
      query,              
      isOnlyActive,       
      teamFilter || null, 
      cityFilter || null, 
      designationFilter || null 
    )
  );
};
 const handleAddEmployeeClick = () => {
  // State is already saved in localStorage
  history.push('/admin/addemployees');
};

  const handleItemsPerPageChange = (value) => {
  if (statusFilter === ACTIVE_STATUS) {
    dispatch(getEmployees(1, value, query, true, teamFilter, cityFilter, designationFilter));
  } else if (statusFilter === DEFAULT_STATUS) {
    dispatch(getEmployees(1, value, query, false, teamFilter, cityFilter, designationFilter));
  } else if (statusFilter === INACTIVE_STATUS) {
    dispatch(getInActiveEmployees(1, value, query, teamFilter, cityFilter, designationFilter));
  }
  setItemsPerPage(value);
  setCurrentPage(1);
};

  const handleEditEmployee = (row) => {
  // State is already saved in localStorage
  history.push({
    pathname: '/admin/UpdateEmployees',
    employee: { row },
    id: row.id
  });
};

  const setButtonPermission = () => {
    if (permissions.includes(PERMISSIONS.CAN_ADD_EMPLOYEE)) {
      setPermission(true);
    }
  };

useEffect(() => {
  if (isInitialized) {
    const filterState = {
      team: teamFilter,
      city: cityFilter,
      designation: designationFilter,
      status: statusFilter,
      search: query,
      page: currentPage,
      pageSize: itemsPerPage,
      showFilters,
      todayAccessed: todayAccessedFilter,
    };
    localStorage.setItem(EMPLOYEE_STATE_KEY, JSON.stringify(filterState));
    sessionStorage.setItem('insideEmployeeModule', 'true');
  }
}, [teamFilter, cityFilter, designationFilter, statusFilter, query, currentPage, itemsPerPage, isInitialized,showFilters, todayAccessedFilter]);

  useEffect(() => {
    const cityBody = {
      filter: { textSearch: "", countryId: "1" },
      pageNumber, pageSize: 0,
    };
    const designationBody = {
      filter: { textSearch: "" },
      pageNumber, pageSize: 0,
    };
    
    dispatch(getEmployeeLookup());


  }, [dispatch]);

 // FIND the useEffect that starts with "initializeFilters" and REPLACE ENTIRE THING:
useEffect(() => {
  const savedState = sessionStorage.getItem(MODULE_FLAG) === "true"
    ? JSON.parse(localStorage.getItem(EMPLOYEE_STATE_KEY) || "null")
    : null;

  if (savedState) {
    setQuery(savedState.search || DEFAULT_SEARCH);
    setPreviousQuery(savedState.search || DEFAULT_SEARCH);
    setCurrentPage(savedState.page || DEFAULT_PAGE);
    setStatusFilter(savedState.status || DEFAULT_STATUS);
    setTeamFilter(savedState.team ?? userTeamId ?? "");
    setCityFilter(savedState.city || "");
    setDesignationFilter(savedState.designation || "");
    setItemsPerPage(savedState.pageSize || DEFAULT_PAGE_SIZE);
    setTodayAccessedFilter(savedState.todayAccessed || "");
    setShowFilters(
    typeof savedState.showFilters === "boolean"
      ? savedState.showFilters
      : false
  );
  } else {
    setQuery(DEFAULT_SEARCH);
    setPreviousQuery(DEFAULT_SEARCH);
    setCurrentPage(DEFAULT_PAGE);
    setStatusFilter(DEFAULT_STATUS);
    setTeamFilter(userTeamId || "");
    setCityFilter("");
    setDesignationFilter("");
    setItemsPerPage(DEFAULT_PAGE_SIZE);
    setTodayAccessedFilter("");
    setShowFilters(false);
  }

  sessionStorage.setItem(MODULE_FLAG, "true");
  setIsInitialized(true);
}, []);



  // Convert name filters to IDs - keeping your existing logic
  useEffect(() => {
    if (teamsData && typeof teamFilter === 'string' && teamFilter) {
      const team = teamsData.find(team => team.name === teamFilter);
      if (team) setTeamFilter(team.id);
    }
    
    if (citiesData && typeof cityFilter === 'string' && cityFilter) {
      const city = citiesData.find(city => city.name === cityFilter);
      if (city) setCityFilter(city.id);
    }
    
    if (designationsData && typeof designationFilter === 'string' && designationFilter) {
      const designation = designationsData.find(designation => designation.name === designationFilter);
      if (designation) setDesignationFilter(designation.id);
    }
  }, [teamsData, citiesData, designationsData, teamFilter, cityFilter, designationFilter]);


useEffect(() => {
  if (!isInitialized) return;

  const inactiveForOverFortyDays = lastLoginFilter === '40';
  const accessedToday = todayAccessedFilter === '' ? null : todayAccessedFilter === 'true';

  if (statusFilter === ACTIVE_STATUS) {
    dispatch(getEmployees(
      currentPage,
      itemsPerPage,
      query,
      true,
      teamFilter,
      cityFilter,
      designationFilter,
      inactiveForOverFortyDays,
      accessedToday
    ));
  } else if (statusFilter === DEFAULT_STATUS) {
    dispatch(getEmployees(
      currentPage,
      itemsPerPage,
      query,
      false,
      teamFilter,
      cityFilter,
      designationFilter,
      inactiveForOverFortyDays,
      accessedToday
    ));
  } else if (statusFilter === INACTIVE_STATUS) {
    dispatch(getInActiveEmployees(
      currentPage,
      itemsPerPage,
      query,
      teamFilter,
      cityFilter,
      designationFilter
    ));
  }

  setButtonPermission();
}, [
  currentPage,
  query,
  statusFilter,
  itemsPerPage,
  teamFilter,
  cityFilter,
  designationFilter,
  lastLoginFilter,
  todayAccessedFilter,
  isInitialized,
  dispatch
]);

  // Data preparation - keeping your existing logic
  const { totalCount, totalPages } = getTotalPaginationInfo();

  const EmployeeData = (() => {
  const getInitials = (firstName, lastName) => {
    const first = firstName?.charAt(0)?.toUpperCase() || '';
    const last = lastName?.charAt(0)?.toUpperCase() || '';
    return `${first}${last}`;
  };
  const getDesignationColor = (designationName) => {
    if (!designationName || !designationsData || designationsData.length === 0) {
      return '#002D72'; 
    }
    const designation = designationsData.find(
      (d) => d.name === designationName
    );
    return designation?.color || '#002D72';
  };
  const getNameWithAvatar = (firstName, lastName, designationName) => {
    const fullName = `${firstName} ${lastName}`;
    const initials = getInitials(firstName, lastName);
    const bgColor = getDesignationColor(designationName);
    
    return (
      <div className="employee-name-container">
        <div className="employee-avatar" style={{ backgroundColor: bgColor }}>
          {initials}
        </div>
        <span className="employee-name-text">{fullName}</span>
      </div>
    );
  };

    const getStatusBadge = (isActive) => (
      <span className={isActive ? "status-badge-active" : "status-badge-inactive"}>
        {isActive ? "Active" : "Inactive"}
      </span>
    );

    const inActiveData = inActiveEmployees.result || [];
  if (statusFilter === 3) {
    return inActiveData?.map((employee) => ({
      ...employee,
      empId: employee.empId ? employee.empId : <span className="not-available-text">Not available</span>,
      fullName: getNameWithAvatar(employee.firstName, employee.lastName, employee.designationName),
      status: getStatusBadge(false),
      lastLogin: formatDate(employee.lastLogin),
    }));
  }
  const data = employees?.result || [];
  return data.map((employee) => ({
    ...employee,
    _select: lastLoginFilter === '40'
      ? (
          <input
            type="checkbox"
            checked={selectedEmployeeIds.includes(employee.id)}
            onChange={() => toggleSelectEmployee(employee.id)}
            aria-label={`Select ${employee.firstName} ${employee.lastName}`}
            style={{ cursor: 'pointer', width: '16px', height: '16px' }}
          />
        )
      : undefined,
    empId: employee.empId ? employee.empId : <span className="not-available-text">Not available</span>,
    fullName: getNameWithAvatar(employee.firstName, employee.lastName, employee.designationName),
    status: getStatusBadge(employee.status),
    todayAccessed: formatTodayAccessed(employee.lastAccessed),
    lastLogin: formatDate(employee.lastLogin),
  }));
})();

  const visibleIds = EmployeeData.map((e) => e.id);
  const allSelected = visibleIds.length > 0 && visibleIds.every((id) => selectedEmployeeIds.includes(id));

  const checkboxColumn = lastLoginFilter === '40'
    ? [{
        label: (
          <input
            type="checkbox"
            checked={allSelected}
            onChange={() => handleSelectAll(visibleIds)}
            aria-label="Select all employees"
            style={{ cursor: 'pointer', width: '16px', height: '16px' }}
          />
        ),
        accessor: '_select',
      }]
    : [];

  const columns = [
    ...checkboxColumn,
    { label: "EmpId", accessor: "empId" },
    { label: `${t("name")}`, accessor: "fullName" },
    { label: `${t("designation")}`, accessor: "designationName" },
    { label: `${t("reportsTo")}`, accessor: "reportToName" },
    { label: `${t("status")}`, accessor: "status" },
    ...(statusFilter === ACTIVE_STATUS
      ? [{ label: "Today accessed", accessor: "todayAccessed" }]
      : []),
    { label: `${t("lastLogin")}`, accessor: "lastLogin" },
  ];

  const actions = [
    {
      label: 'Edit employee',
      icon: <EditOutlinedIcon sx={{ color: '#0438B4' }}/>,
      permission: PERMISSIONS.CAN_UPDATE_EMPLOYEE,
      handler: handleEditEmployee,
    },
  ];

  return (
    <>    
    <div>
    <LoadingOverlay isVisible={isLoading}/>
      <div className="main-container">
        <div className="content-wrapper no-padding">
          <EmployeeHeader
            query={query}
            handleSearchChange={handleSearchChange}
            itemsPerPage={itemsPerPage}
            handleItemsPerPageChange={handleItemsPerPageChange}
            currentPage={currentPage}
            totalCount={totalCount}
            totalPages={totalPages}
            setCurrentPage={setCurrentPage}
            handleEmployeeDownload={handleEmployeeDownload}
            permissions={permissions}
            handleAddEmployeeClick={handleAddEmployeeClick}
            showFilters={showFilters}
            toggleFilters={toggleFilters}
          />

          {/* Updated Filter Bar using the new generic component */}
          <FilterBar 
            showFilters={showFilters}
            onClearAll={handleClearAllFilters}
          >
            <CustomFilterSelect
              label={t("status")}
              width="140px"
              value={statusFilter}
              searchable={false}
              onChange={handleStatusFilterChange}
              options={[
                { id: 1, name: 'All' },
                { id: 2, name: 'Active' },
                { id: 3, name: 'Inactive' },
              ]}
            />

            <CustomFilterSelect
              label={t("team")}
              width="160px"
              value={teamFilter}
              searchPlaceholder="Search team"
              onChange={handleTeamFilterChange}
              options={[
                { id: '', name: 'All' },
                ...(teamsData || []).map(team => ({
                  id: team.id,
                  name: team.name
                }))
              ]}
            />

            <CustomFilterSelect
              label={t("city")}
              width="160px"
              value={cityFilter}
              searchPlaceholder="Search City"
              onChange={handleCityFilterChange}
              options={[
                { id: '', name: 'All' },
                ...(citiesData || []).map(city => ({
                  id: city.id,
                  name: city.name
                }))
              ]}
            />

            <CustomFilterSelect
              label={t("designation")}
              width="180px"
              value={designationFilter}
              searchPlaceholder="Search Designation"
              onChange={handleDesignationFilterChange}
              options={[
                { id: '', name: 'All' },
                ...(designationsData || []).map(designation => ({
                  id: designation.id,
                  name: designation.name
                }))
              ]}
            />

            {permissions && permissions.some(
              (p) => p.toLowerCase() === PERMISSIONS.CAN_SET_INACTIVE.toLowerCase()
            ) && (
              <CustomFilterSelect
                label="Last Login"
                width="140px"
                value={lastLoginFilter}
                searchable={false}
                onChange={handleLastLoginFilterChange}
                options={[
                  { id: '', name: 'All' },
                  { id: '40', name: '40 days' },
                ]}
              />
            )}

            {statusFilter === ACTIVE_STATUS && (
              <CustomFilterSelect
                label="Last Accessed"
                width="190px"
                value={todayAccessedFilter}
                searchable={false}
                onChange={handleTodayAccessedFilterChange}
                options={[
                  { id: '', name: 'All' },
                  { id: 'true', name: 'Yes' },
                  { id: 'false', name: 'No' },
                ]}
              />
            )}
          </FilterBar>

         
        </div>
        <DynamicTable
            data={EmployeeData}
            columns={columns}
            permissions={permissions}
            actions={actions}
            thIcon={thIcon}
            showPagination={totalCount > 0}
            currentPage={currentPage}
            totalItems={totalCount}
            itemsPerPage={itemsPerPage}
            totalPages={totalPages}
            onPageChange={(page) => setCurrentPage(page)}
            onItemsPerPageChange={handleItemsPerPageChange}
          />
      </div>
    </div>

    {/* Floating bulk-action bar — visible only when employees are selected */}
    {selectedEmployeeIds.length > 0 && (
      <div className="bulk-action-bar" role="status" aria-live="polite">
        <span className="bulk-action-count">
          {selectedEmployeeIds.length} employee{selectedEmployeeIds.length > 1 ? 's' : ''} selected
        </span>
        <button
          className="bulk-deactivate-btn"
          onClick={() => setShowDeactivateModal(true)}
          aria-label="Deactivate selected employees"
        >
          Deactivate
        </button>
        <button
          className="bulk-action-close"
          onClick={() => setSelectedEmployeeIds([])}
          aria-label="Clear selection"
        >
          &#x2715;
        </button>
      </div>
    )}

    {/* Deactivate confirmation modal */}
    {showDeactivateModal && (
      <div className="modal-overlay" role="dialog" aria-modal="true" aria-labelledby="deactivate-modal-title">
        <div className="modal-box">
          <div className="modal-icon-wrapper">
            <span className="modal-trash-icon" aria-hidden="true">&#128465;</span>
          </div>
          <h2 className="modal-title" id="deactivate-modal-title">Confirm deactivation</h2>
          <p className="modal-message">Are you sure you want to deactivate selected employees?</p>
          <div className="modal-actions">
            <button
              className="modal-cancel-btn"
              onClick={() => setShowDeactivateModal(false)}
              disabled={isBulkDeactivating}
              aria-label="Cancel deactivation"
            >
              Cancel
            </button>
            <button
              className="modal-confirm-btn"
              onClick={handleConfirmDeactivate}
              disabled={isBulkDeactivating}
              aria-label="Confirm deactivation"
            >
              {isBulkDeactivating ? 'Deactivating...' : 'Deactivate'}
            </button>
          </div>
        </div>
      </div>
    )}
    </>

  );
}

export default Employees;